module.exports = __webpack_public_path__ + "img/ljcy.6329780f.png";